import React from 'react';

export default function ChartLegend({
  items = [
    { value: 'blue', label: 'Observation' },
    { value: 'dashed', label: 'Prediction' },
  ],
}) {
  if (items?.length === 0) {
    return null;
  }

  return (
    <div
      data-component-name='ChartLegend'
      className='rounded-md py-2 px-3 bg-white-400 w-max'
    >
      <div className='flex flex-col'>
        {items &&
          items.map((item, i) => (
            <div key={i}>
              <div className='flex gap-4 items-center'>
                {item.value === 'blue' && (
                  <div className='h-[4px] rounded-full w-10 bg-[#142c60]'></div>
                )}
                {item.value === 'dashed' && (
                  <div className='flex gap-[4px] w-10 justify-center overflow-hidden'>
                    <div className='h-[2px] rounded-full w-[8px] min-w-[8px] bg-[#6A839E99]'></div>
                    <div className='h-[2px] rounded-full w-[8px] min-w-[8px] bg-[#6A839E99]'></div>
                    <div className='h-[2px] rounded-full w-[8px] min-w-[8px] bg-[#6A839E99]'></div>
                    <div className='h-[2px] rounded-full w-[8px] min-w-[8px] bg-[#6A839E99]'></div>
                  </div>
                )}
                <div className='text-xs'>{item.label}</div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
